import * as Sentry from "@sentry/react"
import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { ErrorPage } from "@/app/error"
import { Router } from "@/app/router"
import "@/css/index.css"
import { store } from "@/store"

const root = createRoot(document.getElementById("root") as HTMLElement)

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  console.info("sentry error catching enabled")
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    sendDefaultPii: false,
  })
}

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />} showDialog>
      <Provider store={store}>
        <Router />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
